import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import { fetchUsers, postDeleteUser } from "../../../../../redux/api/admin.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import { removeUserFromUsers } from "../../../../../redux/reducer/admin.reducer";
import { adminRoutes } from "../../../../../router/routesConstants";

function UsersActionButton({ itemId, crudData, tableContext }: any) {
  const dispatch = useAppDispatch();

  const handleDeleteOrActivateUser = async () => {
    const resultAction = await dispatch(postDeleteUser(itemId));

    if (
      checkEndpointStatus(resultAction, postDeleteUser) ===
      endpointStatus.fulfilled
    ) {
      if (
        tableContext.tablePagination.page &&
        tableContext.tablePagination.rowsPerPage &&
        tableContext.tableSearch
      ) {
        dispatch(removeUserFromUsers(itemId));

        dispatch(
          fetchUsers({
            page: tableContext.tablePagination.page,
            perPage: tableContext.tablePagination.rowsPerPage,
            username: tableContext.tableSearch.username,
            firstName: tableContext.tableSearch.firstName,
            lastName: tableContext.tableSearch.lastName,
          }),
        );
      }
    }
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={crudData.userName}
      ariaLabel={`Actiuni pentru utilizatorul ${crudData.userName}`}
      items={[
        {
          id: "edit",
          label: "Editeaza utilizator",
          icon: "EDIT",
          tooltip:
            crudData.deleted !== 0
              ? "Reactiveaza utilizatorul pentru a-i modifica datele."
              : "Modifica datele acestui utilizator.",
          disabled: crudData.deleted !== 0,
          navigate: `/${adminRoutes.users}/${adminRoutes.editUser}?userId=${itemId}`,
        },
        {
          id: "web-roles",
          label: "Roluri web",
          icon: "WEB_ROLES",
          tooltip:
            crudData.deleted !== 0
              ? "Reactiveaza utilizatorul pentru a-i configura rolurile web."
              : "Configureaza permisiunile utilizatorului in aplicatia web.",
          disabled: crudData.deleted !== 0,
          navigate: `/${adminRoutes.users}/${adminRoutes.adminUserWebRoles}?userId=${itemId}&userName=${crudData.userName}`,
        },
        {
          id: "palm-roles",
          label: "Roluri palm",
          icon: "PALM_ROLES",
          tooltip:
            crudData.deleted !== 0
              ? "Reactiveaza utilizatorul pentru a-i configura rolurile palm."
              : "Configureaza permisiunile utilizatorului pe terminalul mobil.",
          disabled: crudData.deleted !== 0,
          navigate: `/${adminRoutes.users}/${adminRoutes.adminUserMobileRoles}?userId=${itemId}&userName=${crudData.userName}`,
        },
        {
          id: "toggle-status",
          dividerBefore: true,
          label: crudData.deleted === 0 ? "Sterge utilizator" : "Activeaza",
          icon: crudData.deleted === 0 ? "DELETE" : "ACTIVATE",
          color: crudData.deleted === 0 ? "error" : "success",
          tooltip:
            crudData.deleted === 0
              ? "Sterge utilizatorul dupa confirmare."
              : "Reactiveaza utilizatorul sters.",
          withConfirmationModal: {
            modalTitle:
              crudData.deleted === 0
                ? "Stergere utilizator"
                : "Activare utilizator",
            modalSubtitle:
              crudData.deleted === 0
                ? `Doriti sa stergeti utilizatorul: ${crudData.userName}?`
                : `Doriti sa activati utilizatorul: ${crudData.userName}?`,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleDeleteOrActivateUser,
          },
        },
      ]}
    />
  );
}

export default UsersActionButton;
